import Vue from 'vue';
import './main.scss';
import * as firebase from 'firebase';

import VueRouter from 'vue-router';
import App from './App.vue';
import Home from './components/Home.vue';
import Retro from './components/pages/Retro.vue';
import Login from './components/pages/Login.vue';
import SignUp from './components/pages/SignUp.vue';
import UserProfile from './components/pages/Profile.vue';
import Team from './components/pages/Team.vue';
import Dashboard from './components/pages/Dashboard.vue';
import Invite from './components/pages/Invite.vue';
import CreateTeam from './components/pages/CreateTeam.vue';
import VerifyUser from './components/pages/VerifyUser.vue';
import Workspace from './components/pages/Workspace.vue';
import Retro_old from './components/pages/Retro_old.vue';
import Page404 from './components/pages/Page-404.vue';
import Clipboard from 'v-clipboard';
import Paginate from 'vuejs-paginate'

import { store } from './store.js';

Vue.config.productionTip = false;

import { firestorePlugin } from 'vuefire';
import Toasted from 'vue-toasted';
Vue.component('paginate', Paginate)

Vue.use(firestorePlugin);
Vue.use(VueRouter);
Vue.use(Clipboard);
Vue.use(Toasted,{
  duration:4000,
  position:'top-center',
  className:'ez-toasted',
  action: {
    text: 'Close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
})

export const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/create-team',
      name: 'createTeam',
      component: CreateTeam,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verify-user',
      name: 'VerifyUser',
      component: VerifyUser,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/profile',
      name: 'userProfile',
      component: UserProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:workspaceId([0-9a-z]{4})/team',
      name: 'team',
      component: Team,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invite/**',
      name: 'invite',
      component: Invite,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:workspaceId([0-9a-z]{4})',
      name: 'Workspace',
      component: Workspace,
      meta: {
        title: ''
      }
    },
    {
      path: '/:workspaceId([0-9a-z]{4})/:retroId([0-9a-z]{4})',
      name: 'Retro',
      component: Retro,
      meta: {
        title: ''
      }
    },
    {
      path: '/:workspaceId([0-9a-zA-Z]{20})',
      name: 'Retro_old',
      component: Retro_old,
      meta: {
        title: ''
      }
    },
    {
      path: '/404',
      name: 'Page-404',
      component: Page404,
      meta: {
        title: '404'
      }
    },
    {
      path: '/*',
      redirect: '/404'
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);

  const currentUser = firebase.auth().currentUser;

  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

let app;
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    });
  }
});
